import { gql } from "@shared/utils";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React, { FunctionComponent, useEffect, useState } from "react";
import { MultiSelectCheckmark } from "../../../MultiSelectCheckmark";

import { useGqlField } from "../../../../hooks";

import { DVInlineProps } from "./types";
import { VariableButton } from "./VariableButton";
import { postTypesObj } from "@shared/core-utils";
import { PostTypes } from "@shared/types";
import { TOutput } from "../../variables";
import VariablePopup from "../DynamicVariables/VariablePopup";

const EDIT_SUBTYPE = gql`
  mutation UpdateDynamicVariable($id: String!, $value: [String!]) {
    updateDynamicVariable(input: { id: $id, subtype: $value }) {
      _id
      subtype
    }
  }
`;
const EDIT_OUTPUT = gql`
  mutation UpdateDynamicVariable($id: String!, $value: String!) {
    updateDynamicVariable(input: { id: $id, output: $value }) {
      _id
      output
    }
  }
`;

export const postTypes: Array<{ name: string; id: string }> = Object.keys(
  postTypesObj
)
  .map((key) => {
    return { name: postTypesObj[key as PostTypes], id: key };
  })
  .reduce((pv, cv) => {
    return [...pv, cv];
  }, [] as Array<{ name: string; id: string }>);

const outputs: Array<{ label: string; value: TOutput }> = [
  {
    value: "EXISTS",
    label: "Exists",
  },
  {
    value: "QUANTITY",
    label: "Quantity",
  },
  {
    value: "HOOKUP",
    label: "Hookup",
  },
];

export const DVInlinePoint: FunctionComponent<DVInlineProps> = ({
  dynamicVariable,
  activeDynamicVariableId,
  setActiveDynamicVariableId,
  removeDynamicVariable,
  onVariableDelete,
  onChange,
  variables,
}) => {
  const [open, setOpen] = useState(false);
  const [subtype, setSubtype] = useGqlField<string[]>(
    dynamicVariable.subtype || [],
    dynamicVariable._id,
    EDIT_SUBTYPE
  );
  const [output, setOutput] = useGqlField(
    dynamicVariable.output,
    dynamicVariable._id,
    EDIT_OUTPUT
  );

  const onModalClose = async () => {
    if (!subtype.length) {
      variables &&
        onChange?.(variables.filter((v) => v !== dynamicVariable._id));
      await removeDynamicVariable?.({
        variables: {
          input: {
            id: dynamicVariable._id,
          },
        },
      });
      onVariableDelete?.(dynamicVariable._id);
    }
  };

  return (
    <>
      <VariablePopup
        title="Edit Post Variable"
        dynamicVariable={dynamicVariable}
        setActiveDynamicVariableId={setActiveDynamicVariableId}
        activeDynamicVariableId={activeDynamicVariableId}
        actions={[]}
        onCancel={() => {
          setOpen(false);
          onModalClose();
        }}
        onSave={() => {
          setOpen(false);
        }}
        onClose={() => {
          setOpen(false);
        }}
        forceOpen={open}
      >
        <VariableButton
          typeLabel="Post"
          variableType="POINT"
          onClick={() => {
            setOpen(true);
          }}
          line1={(dynamicVariable.subtype || [])
            .map((st) => {
              return postTypes.find((t) => t.id === st)?.name || "";
            })
            .join(", ")}
          output={dynamicVariable?.output}
        />
        <Box>
          <MultiSelectCheckmark
            variants={postTypes}
            defaultValue={dynamicVariable?.subtype}
            label="Types"
            onChange={(event) => {
              const val = event.target.value as any[];
              setSubtype(val.map((v) => v.id));
            }}
          />
          <FormControl fullWidth sx={{ marginTop: 2 }}>
            <InputLabel>Output</InputLabel>
            <Select
              label="Output"
              variant="outlined"
              onChange={(e, _v) => {
                setOutput(e.target.value);
              }}
              value={output}
            >
              {outputs.map((o: { label: string; value: string }) => {
                return (
                  <MenuItem value={o.value} key={o.value}>
                    {o.label}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Box>
      </VariablePopup>
    </>
  );
};
